export const FETCH_ITEMS_PAGE_SIZE = import.meta.env.VITE_LOAD_ITEMS_PAGE_SIZE;
export const FETCH_UNGATEGORISED_PAGE_SIZE = import.meta.env
  .VITE_LOAD_UNCATEGORISED_PAGE_SIZE;
